<template>
    <span class="icon" v-bind="$attrs" :aria-hidden="false" aria-label="Light" role="img" @click="$emit('click', $event)">
        <svg :width="size" :height="size" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.75 0.75C8.75 0.335786 8.41422 0 8 0C7.58579 0 7.25 0.335786 7.25 0.75V9.36358L4.29526 6.23503C4.01085 5.93389 3.53617 5.92033 3.23503 6.20474C2.9339 6.48915 2.92033 6.96383 3.20474 7.26497L7.45474 11.765C7.59642 11.915 7.79366 12 8 12C8.20635 12 8.40358 11.915 8.54526 11.765L12.7953 7.26497C13.0797 6.96383 13.0661 6.48915 12.765 6.20474C12.4638 5.92033 11.9892 5.93389 11.7047 6.23503L8.75 9.36358V0.75Z" :fill="fillColor" />
            <path d="M1.5 10.75C1.5 10.3358 1.16421 10 0.75 10C0.335786 10 0 10.3358 0 10.75V13.25C0 14.7688 1.23122 16 2.75 16H13.25C14.7688 16 16 14.7688 16 13.25V10.75C16 10.3358 15.6642 10 15.25 10C14.8358 10 14.5 10.3358 14.5 10.75V13.25C14.5 13.9404 13.9404 14.5 13.25 14.5H2.75C2.05964 14.5 1.5 13.9404 1.5 13.25V10.75Z" :fill="fillColor" />
        </svg>
    </span>
</template>

<script lang="ts" setup>
interface Props {
    fillColor?: string;
    size?: number;
}
defineEmits(['click'])
withDefaults(defineProps<Props>(), {
    fillColor: 'currentColor',
    size: 16
})
</script>